module.exports = __webpack_public_path__ + "static/media/aim.aeddd7c4.svg";